import axios, { AxiosResponse } from "axios";
import { config } from "../../../config";

import { seatMapsApiPrefix } from "../../paths";

import { GetSeatMapRequest, GetSeatMapResponse } from "redmond";

const END_POINT: string = `${seatMapsApiPrefix}`;

export const fetchSeatMap = (
  req: GetSeatMapRequest
): Promise<GetSeatMapResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res: AxiosResponse<GetSeatMapResponse> = await axios.post(END_POINT, req, {
        baseURL: config.baseURL,
      });
      const responseBody = res.data;
      resolve(responseBody);
    } catch (e) {
      reject(e);
    }
  });
